import axios from 'axios'
import store from '../store/index'

const getSecretKey = function (id) {
  let str;
  axios({
    method: 'POST',
    url: baseUrl + '/app/enAppUser',
    data: {
      appId: id
    }
  }).then((res) => {
    str = res.data.obj;
  }).catch((error) => {
  })
  return encodeURIComponent(str);
}

const setMemberAppData = function (data, type) {
  let resultArr = [];
  for (let i = 0; i < data.length; i++) {
    if (data[i].childMenus != null && data[i].childMenus.length != 0) {
      let two = data[i].childMenus;
      for (let k = 0; k < two.length; k++) {
        if (two[k].childMenus != null && two[k].childMenus.length != 0) {
          let three = two[k].childMenus;
          for (let j = 0; j < three.length; j++) {
            if (three[j].childMenus != null) {

            } else if (three[j].apps != null) {
              let obj_three = {};
              obj_three.title = data[i].modulesName + ' > ' + two[k].modulesName + ' > ' + three[j].modulesName;
              obj_three.apps = three[j].apps;
              resultArr.push(obj_three);
            }
          }
        } else if (two[k].apps != null) {
          let obj_two = {};
          obj_two.title = data[i].modulesName + ' > ' + two[k].modulesName;
          obj_two.apps = two[k].apps;
          resultArr.push(obj_two);
        }
      }
    } else if (data[i].apps != null) {
      let obj = {};
      obj.title = data[i].modulesName;
      obj.apps = data[i].apps;
      resultArr.push(obj);
    }
  }
  for (let q = 0; q < resultArr.length; q++) {
    let apps = resultArr[q].apps;
    for (let a = 0; a < apps.length; a++) {
      if (apps[a].appUrl != null && apps[a].appUrl != "" && store.state.memberInfo != '') {
        apps[a].appUrl = apps[a].appUrl.replace("{memberid}", store.state.memberInfo.memberUsername)
        if (apps[a].appUrl.indexOf("{memberAesEncrypt}") > -1) {
          apps[a].appUrl = apps[a].appUrl.replace("{memberAesEncrypt}", getSecretKey(apps[a].appId))
        }
        apps[a].appUrl = apps[a].appUrl.replace("{quicklyTicket}", store.state.memberInfo.quicklyTicket)
      }
      apps[a].appImages = baseUrl + '/public/getImg?path=' + encodeURI(apps[a].appImages)
    }
  }
  if(type == 'yyzx' || type=='cyyy'||type=='cate-list') {
    return resultArr;
  } else if (type == 'index_tjfw') {
    return resultArr[0]['apps'].slice(0,7)
  }else if (type == 'tjfw') {
    return resultArr[0]['apps']
  } else {
    return resultArr[0].apps;
  }
}

const appAccessStatistical = function(id){
  axios({
    method: 'POST',
    url: baseUrl + '/app/statistical/appAccessStatistical',
    data: {
      appAccessAppId: id
    }
  })
}

export default {
  getSecretKey,
  setMemberAppData,
  appAccessStatistical
}
